module.exports = __webpack_public_path__ + "img/twitter-logo.b6c0adc7.png";